import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

import styled from 'styled-components';

export const StyledLinearProgressBar = styled(LinearProgress)({
  [`&.${linearProgressClasses.determinate}`]: { backgroundColor: '#D9D9D9' },
  [`&.${linearProgressClasses.determinate} > .${linearProgressClasses.bar1Determinate}`]: {
    backgroundColor: '#6ECDC5'
  }
});
